export const STORE_PREFIX = 'candidate_';
